import { motion } from "framer-motion";


interface Props {
  templateUrl: string;
  title: string;
  animate?: boolean;
  occasion?: string;
  tint?: string; // Custom tint filter string — overrides occasion-based tint
}

const CardEnvelope = ({ templateUrl, title, animate = false, occasion: _occasion, tint: _tint }: Props) => {
  const envelopeFilter: string | undefined = undefined;
  // Final resting state: card sits inside envelope, top ~40% visible above envelope front
  // Animation: envelope slides down -> card rises up -> card rotates -> card settles into envelope

  return (
    <div
      className="relative mx-auto"
      style={{ width: "100%", maxWidth: 500, aspectRatio: "500/720" }}
    >
      {/* Envelope back (behind everything) */}
      <img
        src="/images/envelope-back.png"
        alt=""
        className="absolute left-0 right-0 bottom-0 w-full pointer-events-none"
        style={{ zIndex: 0, filter: envelopeFilter }}
      />

      {/* Card holder - the card that rises and settles inside envelope */}
      <motion.div
        className="absolute left-1/2 z-[1]"
        style={{
          width: "78%",
          x: "-50%",
          aspectRatio: "360/508",
        }}
        // Final position: card top is above envelope, bottom hidden behind envelope-front
        // top ~8% puts the card peeking out from the envelope
        initial={animate ? { top: "60%", rotate: -90, scale: 0.9 } : { top: "5%", rotate: 0, scale: 1 }}
        animate={{ top: "5%", rotate: 0, scale: 1 }}
        transition={
          animate
            ? {
                top: { delay: 1.0, duration: 1.2, ease: [0.34, 1.56, 0.64, 1] },
                rotate: { delay: 1.6, duration: 1.0, ease: "easeInOut" },
                scale: { delay: 1.6, duration: 1.0, ease: "easeInOut" },
              }
            : undefined
        }
      >
        <div
          className="w-full h-full overflow-hidden bg-white"
          style={{
            boxShadow: "0px 0px 15px 5px rgba(0, 0, 0, 0.08)",
            aspectRatio: "360/508",
          }}
        >
          {templateUrl && (
            <img
              src={templateUrl}
              alt="Card"
              className="w-full h-full object-cover"
            />
          )}
          {title && !templateUrl && (
            <div className="flex items-center justify-center h-full p-6">
              <h3
                className="text-2xl md:text-3xl font-bold text-center text-foreground"
                style={{ fontFamily: "'Bricolage Grotesque', sans-serif" }}
              >
                {title}
              </h3>
            </div>
          )}
        </div>
      </motion.div>

      {/* Envelope front (overlaps bottom of card) */}
      <img
        src="/images/envelope-front.png"
        alt=""
        className="absolute left-0 right-0 bottom-0 w-full pointer-events-none"
        style={{ zIndex: 8, filter: envelopeFilter }}
      />

      {/* Logo on envelope */}
      <span
        className="absolute left-0 right-0 text-center text-[10px] font-logo font-extralight tracking-[0.35em] uppercase text-muted-foreground/40"
        style={{ bottom: "7.5%", zIndex: 9 }}
      >
        Joyn
      </span>
    </div>
  );
};

export default CardEnvelope;
